// import { GetProfileView } from 'services/Api/Module/Profile';
import { persist } from 'zustand/middleware'
import { create } from 'zustand';
import { GetCustomerProfile } from 'services/Api/Module/Customer';

const defaultLineUid = '$lineUid'
const defaultProfile = { isLoaded: false, lineUid: defaultLineUid, profile: {} }

const useProfileStore = create(
      (set) => ({
        isLoaded: false,
        lineUid: defaultLineUid,
        profile: defaultProfile,
        customerProfile: {},

        setProfile: (payload = { lineUid: '', profile: {} })=> {
          // set({ isLoaded: true });
          set({ isLoaded: true, lineUid: payload.lineUid, profile: payload.profile });
        },

        getCustomerProfile: async (lineId = 'xxx') => {
          try {
            const response = await GetCustomerProfile({ params: { lineUid: lineId } });
            const resData = response.data
            if(resData.resultCode === 20000){
              set({ customerProfile: resData.resultData });
            }
            
            return resData;
          } catch (error) {
            console.error('Error adding customer:', error);
            // return error;
            throw error;
          }
        },
    
        resetProfile: (payload = { lineUid: '', profile: {} })=> {
          set({ isLoad: true });
          set({ lineUid: defaultLineUid, profile: defaultProfile });
          set({ profileData: {} });
        }
      }
    )
);

export default useProfileStore;